export default __webpack_public_path__ + "static/media/compare-schedule-white.4788604a.svg";